import styled from "styled-components";

const FooterSlantedSection = () => {
  return (
    <Container>
      <LeftTriangle />
      <CenterTrapezoid />
      <RightTriangle />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 250px;

  @media (max-width: 767px) {
    // display: flex;
    // position: absolute;
    max-height: 100%;
  }
`;

const LeftTriangle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #69c3f4, #7e72e6);
  clip-path: polygon(0% 0%, 81.2% 75%, 100% 100%, 0% 100%);

  @media (max-width: 767px) {
    height: 50%;
    clip-path: polygon(0% 0%, 81.2% 75%, 100% 100%, 0% 100%);
  }
`;

const CenterTrapezoid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0a2472;
  z-index: 1;
  clip-path: polygon(81.2% 75%, 100% 100%, 100% 100%, 0% 100%);

  @media (max-width: 767px) {
    height: 50%;
  }
`;

const RightTriangle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: orange;
  clip-path: polygon(81.2% 75%, 100% 69.8%, 100% 100%, 0% 100%);

  @media (max-width: 767px) {
    height: 50%;
  }
`;

export default FooterSlantedSection;
